import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import locationIcon from "../../../../assets/img/location-icon.svg";
import calendarIcon from "../../../../assets/img/calendar-icon.svg";
import icon263 from "../../../../assets/img/Icon-263.svg";

const EventCard = ({ className = "", id, title, location, dates, description }) => {
  const navigate = useNavigate();
  return (
    <section
      className={`w-full rounded-[20px] bg-[#fff] border-[#d9d9d9] border-solid border-[1px] box-border flex flex-col items-start p-[1.25rem] sm:p-[1.5rem] lg:p-[2rem] z-[3] text-left text-[1rem] text-[#111827] font-[Inter] ${className}`}
    >
      <div className="w-full flex flex-col gap-[1.25rem] lg:flex-row lg:items-start lg:justify-between">
        <div className="flex w-full lg:flex-1 flex-col items-start gap-[0.625rem] min-w-0">
          <h3 className="m-0 self-stretch text-[1.125rem] sm:text-[1.25rem] lg:text-[1.5rem] font-semibold break-words">
            {title}
          </h3>
          <div className="w-full flex flex-col items-start gap-[0.312rem] text-[#6b7280]">
            {location && (
              <div className="self-stretch flex items-center gap-[0.625rem]">
                <img
                  className="h-[1.125rem] w-[1.125rem] sm:h-[1.25rem] sm:w-[1.25rem] shrink-0"
                  alt=""
                  src={locationIcon}
                />
                <div className="text-[0.875rem] sm:text-[1rem] leading-[130.03%] break-words">{location}</div>
              </div>
            )}
            <div className="self-stretch flex items-center gap-[0.625rem]">
              <img
                className="h-[1.125rem] w-[1.125rem] sm:h-[1.25rem] sm:w-[1.25rem] shrink-0"
                alt=""
                src={calendarIcon}
              />
              <div className="text-[0.875rem] sm:text-[1rem] leading-[130.03%] break-words">
                {dates}
              </div>
            </div>
          </div>
          {!!description && (
            <div className="w-full text-[0.875rem] sm:text-[1rem] leading-[130.03%] break-words">
              {description}
            </div>
          )}
        </div>

        <div className="flex w-full lg:w-auto flex-col items-stretch lg:items-center gap-[0.625rem] text-[#9ca3af]">
          <div className="flex items-center gap-[0.312rem] justify-start lg:justify-center">
            <img
              className="h-[1rem] w-[1rem]"
              loading="lazy"
              alt=""
              src={icon263}
            />
            <i className="text-[0.812rem] sm:text-[0.875rem] leading-[1.25rem]">
              Заявки принимаются до: 01.10.2026 23:59
            </i>
          </div>
          <button
            type="button"
            onClick={() => navigate(`/participant/events/${id}/apply`)}
            className="cursor-pointer [border:none] py-[0.875rem] sm:py-[1rem] px-[1rem] bg-[#0D9488] w-full lg:w-[21.875rem] rounded-[10px] flex items-center justify-center box-border text-[1rem] sm:text-[1.25rem] lg:text-[1.5rem] font-semibold font-[Inter] text-[#fff]"
          >
            Подать заявку
          </button>
        </div>
      </div>
    </section>
  );
};

EventCard.propTypes = {
  className: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  location: PropTypes.string,
  dates: PropTypes.string,
  description: PropTypes.string,
};

export default EventCard;
